import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: []
    },
    LastName: {
      validations: []
    },
    TelNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    Email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    Category: {
      validations: []
    },
    PaymentMethod: {
      validations: []
    },
    BillClientName: {
      validations: []
    },
    Reference: {
      validations: []
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    PlannedGuestCount: {
      validations: [
        { type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.'}
      ]
    },
    StartTime: {
      validations: []
    }, 
    EndTime: {
      validations: []
    },
    PartyName: {
      validations: []
    },
    Theme: {
      validations: []
    },
    SiteName: {
      validations: []
    },
    SiteAddress: {
      validations: []
    },
    Notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name',
            mapping: 'FirstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number',
            mapping: 'TelNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email',
            mapping: 'Email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Category',
            options: [
              {label: 'Delivery', value: 'Delivery'},
              {label: 'Pick-Up', value: 'Pick-Up'},
            ],
            mapping: 'Category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Payment Method',
            options: [
              {label: 'Department Cost Center' , value: 'Department Cost Center'},
              {label: 'Credit Card' , value: 'Credit Card'},
              {label: 'Cash' , value: 'Cash'},
              {label: 'Check' , value: 'Check'},
              {label: 'Payroll Deduct' , value: 'Payroll Deduct'},
            ],
            mapping: 'PaymentMethod'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Cost Center',
            mapping: 'BillClientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Badge Number/# Pay Periods',
            mapping: 'Reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker-nofill',
            size: 'Medium',
            label: 'Event Date',
            mapping: 'EventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated # of Guests',
            mapping: 'PlannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Start Time',
            options: [
              { label: '6:00 AM', value: '6:00 AM' },
              { label: '6:15 AM', value: '6:15 AM' },
              { label: '6:30 AM', value: '6:30 AM' },
              { label: '6:45 AM', value: '6:45 AM' },
              { label: '7:00 AM', value: '7:00 AM' },
              { label: '7:15 AM', value: '7:15 AM' },
              { label: '7:30 AM', value: '7:30 AM' },
              { label: '7:45 AM', value: '7:45 AM' },
              { label: '8:00 AM', value: '08:00:00' },
              { label: '8:15 AM', value: '08:15:00' },
              { label: '8:30 AM', value: '08:30:00' },
              { label: '8:45 AM', value: '08:45:00' },
              { label: '9:00 AM', value: '09:00:00' },
              { label: '9:15 AM', value: '09:15:00' },
              { label: '9:30 AM', value: '09:30:00' },
              { label: '9:45 AM', value: '09:45:00' },
              { label: '10:00 AM', value: '10:00:00' },
              { label: '10:15 AM', value: '10:15:00' },
              { label: '10:30 AM', value: '10:30:00' },
              { label: '10:45 AM', value: '10:45:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '11:15 AM', value: '11:15:00' },
              { label: '11:30 AM', value: '11:30:00' },
              { label: '11:45 AM', value: '11:45:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '12:15 PM', value: '12:15:00' },
              { label: '12:30 PM', value: '12:30:00' },
              { label: '12:45 PM', value: '12:45:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '1:15 PM', value: '13:15:00' },
              { label: '1:30 PM', value: '13:30:00' },
              { label: '1:45 PM', value: '13:45:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '2:15 PM', value: '14:15:00' },
              { label: '2:30 PM', value: '14:30:00' },
              { label: '2:45 PM', value: '14:45:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '3:15 PM', value: '15:15:00' },
              { label: '3:30 PM', value: '15:30:00' },
              { label: '3:45 PM', value: '15:45:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '4:15 PM', value: '16:15:00' },
              { label: '4:30 PM', value: '16:30:00' },
              { label: '4:45 PM', value: '16:45:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '5:15 PM', value: '17:15:00' },
              { label: '5:30 PM', value: '17:30:00' },
              { label: '5:45 PM', value: '17:45:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '6:15 PM', value: '18:15:00' },
              { label: '6:30 PM', value: '18:30:00' },
              { label: '6:45 PM', value: '18:45:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '7:15 PM', value: '19:15:00' },
              { label: '7:30 PM', value: '19:30:00' },
              { label: '7:45 PM', value: '19:45:00' },
              { label: '8:00 PM', value: '20:00:00' },
              { label: '8:15 PM', value: '20:15:00' },
              { label: '8:30 PM', value: '20:30:00' },
              { label: '8:45 PM', value: '20:45:00' },
              { label: '9:00 PM', value: '21:00:00' },
              { label: '9:15 PM', value: '21:15:00' },
              { label: '9:30 PM', value: '21:30:00' },
              { label: '9:45 PM', value: '21:45:00' },
              { label: '10:00 PM', value: '22:00:00' },
              { label: '10:15 PM', value: '22:15:00' },
              { label: '10:30 PM', value: '22:30:00' },
              { label: '10:45 PM', value: '22:45:00' },
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:15 PM', value: '23:15:00' },
              { label: '11:30 PM', value: '23:30:00' },
            ],
            mapping: 'StartTime'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'End Time',
            options: [
              { label: '6:00 AM', value: '6:00 AM' },
              { label: '6:15 AM', value: '6:15 AM' },
              { label: '6:30 AM', value: '6:30 AM' },
              { label: '6:45 AM', value: '6:45 AM' },
              { label: '7:00 AM', value: '7:00 AM' },
              { label: '7:15 AM', value: '7:15 AM' },
              { label: '7:30 AM', value: '7:30 AM' },
              { label: '7:45 AM', value: '7:45 AM' },
              { label: '8:00 AM', value: '08:00:00' },
              { label: '8:15 AM', value: '08:15:00' },
              { label: '8:30 AM', value: '08:30:00' },
              { label: '8:45 AM', value: '08:45:00' },
              { label: '9:00 AM', value: '09:00:00' },
              { label: '9:15 AM', value: '09:15:00' },
              { label: '9:30 AM', value: '09:30:00' },
              { label: '9:45 AM', value: '09:45:00' },
              { label: '10:00 AM', value: '10:00:00' },
              { label: '10:15 AM', value: '10:15:00' },
              { label: '10:30 AM', value: '10:30:00' },
              { label: '10:45 AM', value: '10:45:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '11:15 AM', value: '11:15:00' },
              { label: '11:30 AM', value: '11:30:00' },
              { label: '11:45 AM', value: '11:45:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '12:15 PM', value: '12:15:00' },
              { label: '12:30 PM', value: '12:30:00' },
              { label: '12:45 PM', value: '12:45:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '1:15 PM', value: '13:15:00' },
              { label: '1:30 PM', value: '13:30:00' },
              { label: '1:45 PM', value: '13:45:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '2:15 PM', value: '14:15:00' },
              { label: '2:30 PM', value: '14:30:00' },
              { label: '2:45 PM', value: '14:45:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '3:15 PM', value: '15:15:00' },
              { label: '3:30 PM', value: '15:30:00' },
              { label: '3:45 PM', value: '15:45:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '4:15 PM', value: '16:15:00' },
              { label: '4:30 PM', value: '16:30:00' },
              { label: '4:45 PM', value: '16:45:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '5:15 PM', value: '17:15:00' },
              { label: '5:30 PM', value: '17:30:00' },
              { label: '5:45 PM', value: '17:45:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '6:15 PM', value: '18:15:00' },
              { label: '6:30 PM', value: '18:30:00' },
              { label: '6:45 PM', value: '18:45:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '7:15 PM', value: '19:15:00' },
              { label: '7:30 PM', value: '19:30:00' },
              { label: '7:45 PM', value: '19:45:00' },
              { label: '8:00 PM', value: '20:00:00' },
              { label: '8:15 PM', value: '20:15:00' },
              { label: '8:30 PM', value: '20:30:00' },
              { label: '8:45 PM', value: '20:45:00' },
              { label: '9:00 PM', value: '21:00:00' },
              { label: '9:15 PM', value: '21:15:00' },
              { label: '9:30 PM', value: '21:30:00' },
              { label: '9:45 PM', value: '21:45:00' },
              { label: '10:00 PM', value: '22:00:00' },
              { label: '10:15 PM', value: '22:15:00' },
              { label: '10:30 PM', value: '22:30:00' },
              { label: '10:45 PM', value: '22:45:00' },
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:15 PM', value: '23:15:00' },
              { label: '11:30 PM', value: '23:30:00' },
            ],
            mapping: 'EndTime'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Party Name',
            mapping: 'PartyName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Theme',
            options: [
              {label: 'Professional Setup', value: 'Professional Setup'},
              {label: 'Disposable Drop Off', value: 'Disposable Drop Off'},
            ],
            mapping: 'Theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Meeting Room',
            mapping: 'SiteName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Location Address',
            mapping: 'SiteAddress'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Menu Selection',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Stillwater Medical Center Contact Form',
    formId: '579',
    clientKey: '89A6DEC0-4275-4F60-80A0-B21AD0D50D86',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you for your order! A member of our team will be in contact should there be any questions or we are not able to accommodate your request.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/stillwatermedical/form_structure.js